//

export default function WebbDividerMedium() {

  return (
  <>
    <div className="pb-3"></div>
  </>
  )
}